export default (courseProgressId: string): string => `localCourseProgress~${courseProgressId}`;
